import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useCommonApi } from '../../../api';
import { RegistryCodeNote, RegistryIdName, RegistryType } from '../../types/accident';
import { AccountingDocument } from '../type/accountingDocuments';

export const useAccountingDocumets = () => {
  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [editingDocument, setEditingDocument] = useState<AccountingDocument | null>(null);

  const [openRemoveDocumentIdDialog, setOpenRemoveDocumentIdDialog] = useState<number | null>(null);

  const { data: accountingCentres } = useQuery<RegistryIdName[]>(
    useCommonApi().getRegistryList(RegistryType.ACCOUNTING_CENTERS)
  );
  const { data: documentCodes, isLoading: isLoadingDocumentTypes } = useQuery<RegistryCodeNote[]>(
    useCommonApi().getRegistryList(RegistryType.ACCOUNTING_DOCUMENTS)
  );
  const { data: accountingDocumentsInvoices, isLoading: isLoadingInvoices } = useQuery({
    ...useCommonApi().getAccountingDocumentsInvoices(),
    enabled: openNewDialog
  });

  const { mutate: createCashReceipt, isPending: isCreatingCashReceipt } = useMutation(
    useCommonApi().createCashReceipt()
  );
  const { mutate: removeDocument, isPending: isRemoving } = useMutation(useCommonApi().removeAccountantDocument());
  const { mutate: editDocument, isPending: isEditing } = useMutation(useCommonApi().editAccountantDocument());

  const handleClose = () => {
    setOpenNewDialog(false);
    setTimeout(() => {
      setEditingDocument(null);
    }, 200);
  };

  const handleRemoveDocument = () => {
    if (openRemoveDocumentIdDialog) {
      removeDocument({ documentId: openRemoveDocumentIdDialog });
      setOpenRemoveDocumentIdDialog(null);
    }
  };

  const startEdit = (doc: AccountingDocument) => {
    setEditingDocument(doc);
    setOpenNewDialog(true);
  };

  return {
    accountingCentres,
    documentCodes,
    isLoadingDocumentTypes,
    openNewDialog,
    setOpenNewDialog,
    editingDocument,
    setEditingDocument,
    openRemoveDocumentIdDialog,
    setOpenRemoveDocumentIdDialog,
    createCashReceipt,
    isCreatingCashReceipt,
    removeDocument,
    isRemoving,
    editDocument,
    isEditing,
    handleClose,
    handleRemoveDocument,
    accountingDocumentsInvoices,
    isLoadingInvoices,
    startEdit
  };
};
